export default class BillDiscoveryItem {
    _biller;
    _verification;

    constructor(biller) {
        this.biller = biller;
        this.verification = "";
    }

    set biller(value) { this._biller = value; }
    set verification(value) { this._verification = value; }

    get biller() { return this._biller; }
    get verification() { return this._verification; }

    static init(biller) {
        return new BillDiscoveryItem(biller);
    }
}